import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  View,
  Flex,
} from "@aws-amplify/ui-react";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { DataGrid } from '@mui/x-data-grid';

import MaterialButton from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import NewUserDialog from "../Components/Overlays/NewUserDialog";
import NewUserGroupDialog from "../Components/Overlays/NewUserGroupDialog";

import { post, deleteUser, getAllUsers } from "../services/UserService";
import formatDate from "../utils/formatDate";
import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";

const columns = [
  { field: 'userId', headerName: 'PasientID', width: 200 },
  {
    field: 'firstName',
    headerName: 'Fornavn',
    width: 220,
    editable: false,
  },

  {
    field: 'arrivalDate',
    headerName: 'Ankomst',
    type: 'dateTime',
    width: 200,
    editable: false,
    valueGetter: (params) => {
      if (params.value == null) {
        return '';
      }
      const valueFormatted = formatDate(params.value)
      return `${valueFormatted}`;
    }
  },
  {
    field: 'departureDate',
    headerName: 'Avreise',
    type: 'dateTime',
    width: 200,
    editable: false,
    valueGetter: (params) => {
      if (params.value == null) {
        return '';
      }
      const valueFormatted = formatDate(params.value)
      return `${valueFormatted}`;
    }
  },
  {
    field: 'groupId',
    headerName: 'Gruppe',
    width: 200,
    editable: false,
  },
  {
    field: 'isWinter',
    headerName: 'Sesong',
    width: 200,
    editable: false,
    valueGetter: (params) => {
      if (params.value == null) {
        return '';
      }
      const valueFormatted = formatSeason(params.value)
      return `${valueFormatted}`;
    }
  },
];

function Admin() {
  let currentDate = new Date();

  const [open, setOpen] = React.useState(false);
  const [isDeletingUser, setIsDeletingUser] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState(false);
  const [bulkDeleteError, setBulkDeleteError] = useState('');
  const [pNR, setpNr] = useState(100)
  const [name, setName] = useState("")
  const [isWinter, setIsWinter] = useState(true);

  const [value, setValue] = useState(0);

  const [userData, setUserData] = useState([])
  const [shownData, setShownData] = useState([])
  const [arrivalDate, setArrivalDate] = useState(new Date());
  const [departureDate, setDepartureDate] = useState(new Date());
  const [group, setGroup] = React.useState('Gronn');
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [isNew, setIsNew] = useState(true)
  const [userInst, setUserInst] = useState('')

  const [groupDialogOpen, setGroupDialogOpen] = useState(false);
  const [parsedUsers, setParsedUsers] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);

  const selectHandleChange = (event) => {
    setGroup(event.target.value);
  };

  const pNRHandleChange = (event) => {
    setpNr(event.target.value);
  };

  const nameHandleChange = (event) => {
    setName(event.target.value);
  };

  const isWinterHandleChange = (event) => {
    setIsWinter(event.target.checked);
  };

  const handleClickOpen = async () => {
    if (!isNew) {
      setName("")
      setpNr(100)
      setGroup('')
      setArrivalDate(new Date())
      setDepartureDate(new Date())
      setIsNew(true)
      setIsWinter(true)
    } else {
      setName("")
      setpNr(100)
      setGroup('')
    }

    setDialogTitle("Ny bruker")
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

  };

  const handleClickOpenGroup = () => {
    setGroup('');
    setArrivalDate(new Date());
    setDepartureDate(new Date());
    setIsWinter(true);
    setParsedUsers([]);
    setGroupDialogOpen(true);
  };

  const handleCloseGroup = () => {
    setGroupDialogOpen(false);
  };

  const parsePastedUsers = (text) => {
    const lines = text.split('\n').map((line) => line.trim()).filter((line) => line.length > 0);

    // Spreadsheet apps (Numbers, Excel, Sheets) paste each row as one line with columns
    // separated by a tab (or comma/semicolon). Split those rows directly if detected.
    const delimiter = [/\t+/, /;/, /,/].find((pattern) => lines.length > 0 && lines.every((line) => pattern.test(line)));

    if (delimiter) {
      return lines.map((line) => {
        const [firstName = '', userId = ''] = line.split(delimiter).map((part) => part.trim());
        return { firstName, userId };
      });
    }

    // Otherwise fall back to alternating lines: name, number, name, number, ...
    const users = [];
    for (let i = 0; i < lines.length; i += 2) {
      if (lines[i + 1] !== undefined) {
        users.push({ firstName: lines[i], userId: lines[i + 1] });
      }
    }
    return users;
  };

  const handlePasteTextChange = (text) => {
    setParsedUsers(parsePastedUsers(text));
  };

  const handleSaveGroup = () => {
    setGroupDialogOpen(false);

    const validUsers = parsedUsers.filter((user) => user.firstName.trim() && user.userId.trim());

    validUsers.forEach((user) => {
      let patient_object = null;

      if (userInst === '01') {
        patient_object = {
          userId: user.userId,
          groupId: group,
          firstName: user.firstName,
          arrivalDate: arrivalDate,
          departureDate: departureDate,
          instId: userInst,
          isWinter: isWinter
        }
      }
      post(patient_object)
    });

    setParsedUsers([]);
  };

  const handleSave = () => {
    setOpen(false);

    let patient_object = null

    if (userInst === '01') {
      patient_object = {
        userId: pNR,
        groupId: group,
        firstName: name,
        arrivalDate: arrivalDate,
        departureDate: departureDate,
        instId: userInst,
        isWinter: isWinter
      }

    }
    post(patient_object)
  }

  const handleDeleteUser = async () => {
    setIsDeletingUser(true);
    try {
      const status = await deleteUser(pNR);
      if (status < 200 || status >= 300) {
        window.alert('Kunne ikke slette brukeren. Prøv igjen.');
        return;
      }

      const isNotDeletedUser = (user) => String(user.userId) !== String(pNR);
      setUserData((users) => users.filter(isNotDeletedUser));
      setShownData((users) => users.filter(isNotDeletedUser));
      setSelectionModel((ids) => ids.filter((id) => String(id) !== String(pNR)));
      setOpen(false);
    } catch (error) {
      console.error('Error deleting user:', error);
      window.alert('Kunne ikke slette brukeren. Prøv igjen.');
    } finally {
      setIsDeletingUser(false);
    }
  };

  const handleOpenBulkDelete = () => {
    setBulkDeleteError('');
    setBulkDeleteDialogOpen(true);
  };

  const handleDeleteSelectedUsers = async () => {
    const selectedIds = [...selectionModel];
    if (!selectedIds.length) {
      setBulkDeleteDialogOpen(false);
      return;
    }

    setIsDeletingUser(true);
    setBulkDeleteError('');
    const deletedIds = [];
    const failedIds = [];

    for (const userId of selectedIds) {
      try {
        const status = await deleteUser(userId);
        if (status >= 200 && status < 300) {
          deletedIds.push(userId);
        } else {
          failedIds.push(userId);
        }
      } catch (error) {
        console.error(`Error deleting user ${userId}:`, error);
        failedIds.push(userId);
      }
    }

    if (deletedIds.length) {
      const deletedIdSet = new Set(deletedIds.map(String));
      const isNotDeletedUser = (user) => !deletedIdSet.has(String(user.userId));
      setUserData((users) => users.filter(isNotDeletedUser));
      setShownData((users) => users.filter(isNotDeletedUser));
      setSelectionModel(failedIds);
    }

    setIsDeletingUser(false);
    if (failedIds.length) {
      setBulkDeleteError(`${deletedIds.length} slettet, ${failedIds.length} kunne ikke slettes. Prøv igjen for brukerne som gjenstår.`);
    } else {
      setBulkDeleteDialogOpen(false);
    }
  };

  useEffect(() => {

    getInst()


  }, []);


  const getUserData = async (inst) => {
    try {
      const data = await getAllUsers(inst)

      if (!data || !data.Items) {
        return
      }

      setUserData(data.Items)
      setShownData(data.Items)
    } finally {
      setIsLoadingUsers(false)
    }
  }

  const getInst = async () => {

    let user = await Auth.currentAuthenticatedUser();

    setUserInst(user.attributes.zoneinfo)
    getUserData(user.attributes.zoneinfo)
  }


  const handleChange = (event, newValue) => {
    setValue(newValue);

    switch (newValue) {
      case 0: filterPreviousUsers()
        break;
      case 1: filterCurrentUsers()
        break;
      case 2: filterFutureUsers()

    }
  };

  const handleRowClick = (e) => {
    setDialogTitle("Rediger bruker");
    setOpen(true);
    setName(e.row.firstName);
    setpNr(e.row.userId);
    setGroup(e.row.groupId);
    setArrivalDate(new Date(e.row.arrivalDate));
    setDepartureDate(e.row.departureDate ? new Date(e.row.departureDate) : null);
    setIsWinter(e.row.isWinter);
    setIsNew(false);
  };

  const filterFutureUsers = () => {
    setShownData(userData.filter(value => new Date(value.arrivalDate).getTime() > new Date(currentDate).getTime()))
  }

  const filterCurrentUsers = () => {

    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }

    let firstSort = userData.filter(value => new Date(value.arrivalDate).getTime() <= new Date(currentDate).getTime())

    setShownData(firstSort.filter(value => new Date(value.arrivalDate).addDays(20).getTime() > new Date(currentDate).getTime()))
  }

  const filterPreviousUsers = () => {

    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }

    setShownData(userData.filter(value => new Date(value.arrivalDate).addDays(20).getTime() < new Date(currentDate).getTime()))
  }

  const searchableData = shownData.filter((row) => {
    const search = searchValue.trim().toLowerCase();
    return !search || String(row.userId).toLowerCase().includes(search) ||
      String(row.firstName || '').toLowerCase().includes(search);
  });

  const showLoadingState = isLoadingUsers;

  return (
    <View className="App" style={{ minHeight: '100vh', backgroundColor: '#FFFFFF' }}>
      <Flex direction="column" style={{ height: '100vh', minHeight: 0 }}>
        <NewUserDialog
          open={open}
          title={dialogTitle}
          isEditing={!isNew}
          isDeleting={isDeletingUser}
          onClose={handleClose}
          onSave={handleSave}
          onDelete={handleDeleteUser}
          userInst={userInst}
          pNR={pNR}
          onPNRChange={pNRHandleChange}
          name={name}
          onNameChange={nameHandleChange}
          group={group}
          onGroupChange={selectHandleChange}
          arrivalDate={arrivalDate}
          onArrivalDateChange={(date) => setArrivalDate(date)}
          departureDate={departureDate}
          onDepartureDateChange={(date) => setDepartureDate(date)}
          isWinter={isWinter}
          onIsWinterChange={isWinterHandleChange}
        />

        <Dialog
          open={bulkDeleteDialogOpen}
          onClose={() => {
            if (!isDeletingUser) {
              setBulkDeleteDialogOpen(false);
            }
          }}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: '10px', backgroundColor: '#FFFFFF' } }}
        >
          <DialogTitle sx={{ color: '#17233D', fontWeight: 700 }}>Slett valgte brukere?</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: '#687895', lineHeight: 1.6 }}>
              Du er i ferd med å slette {selectionModel.length} brukere. Denne handlingen kan ikke angres.
            </DialogContentText>
            {bulkDeleteError && (
              <Box role="alert" sx={{ mt: 1.5, color: '#B42318', fontSize: 14 }}>
                {bulkDeleteError}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <MaterialButton
              onClick={() => setBulkDeleteDialogOpen(false)}
              disabled={isDeletingUser}
              sx={{ color: '#64748B', textTransform: 'none' }}
            >
              Avbryt
            </MaterialButton>
            <MaterialButton
              onClick={handleDeleteSelectedUsers}
              disabled={isDeletingUser || selectionModel.length === 0}
              variant="contained"
              color="error"
              startIcon={<DeleteOutlineIcon />}
              sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none' }}
            >
              {isDeletingUser ? 'Sletter...' : `Slett ${selectionModel.length} brukere`}
            </MaterialButton>
          </DialogActions>
        </Dialog>

        <NewUserGroupDialog
          open={groupDialogOpen}
          onClose={handleCloseGroup}
          onSave={handleSaveGroup}
          userInst={userInst}
          onPasteTextChange={handlePasteTextChange}
          parsedUsers={parsedUsers}
          onUsersChange={setParsedUsers}
          group={group}
          onGroupChange={selectHandleChange}
          arrivalDate={arrivalDate}
          onArrivalDateChange={(date) => setArrivalDate(date)}
          departureDate={departureDate}
          onDepartureDateChange={(date) => setDepartureDate(date)}
          isWinter={isWinter}
          onIsWinterChange={isWinterHandleChange}
        />

        <Container
          disableGutters
          sx={{ width: 'auto', maxWidth: 'none', margin: '0 24px', boxSizing: 'border-box', borderBottom: '1px solid #E5E7EB', flexShrink: 0 }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              minHeight: 42,
              justifyContent: 'flex-start',
              '& .MuiTabs-flexContainer': {
                justifyContent: 'flex-start',
              },
              '& .MuiTabs-indicator': { height: 2 },
              '& .MuiTab-root': {
                minHeight: 42,
                minWidth: 105,
                padding: '0 14px',
                color: '#64748B',
                fontSize: 12,
                fontWeight: 600,
                textTransform: 'uppercase',
              },
              '& .Mui-selected': {
                color: '#00B6CD',
                fontWeight: 700,
              },
            }}
          >
            <Tab label="Tidligere" />
            <Tab label="Nåværende" />
            <Tab label="Kommende" />
          </Tabs>
        </Container>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, width: '100%', padding: '12px 24px', boxSizing: 'border-box', flexShrink: 0 }}>
          <TextField
            size="small"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            placeholder="Søk på ID eller navn"
            inputProps={{ 'aria-label': 'Søk på ID eller navn' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              width: 545,
              '& .MuiOutlinedInput-root': {
                height: 40,
                borderRadius: '10px',
                '& fieldset': { borderColor: '#E5E7EB' },
                '&:hover fieldset': { borderColor: '#CBD5E1' },
                '&.Mui-focused fieldset': { borderColor: '#CBD5E1' },
              },
              '& .MuiInputBase-input': { fontSize: 14 },
              flexShrink: 0,
            }}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            {selectionModel.length > 0 && (
              <MaterialButton
                variant="outlined"
                color="error"
                onClick={handleOpenBulkDelete}
                startIcon={<DeleteOutlineIcon sx={{ fontSize: 18 }} />}
                sx={{ height: 40, borderRadius: '10px', textTransform: 'none', fontSize: 14, fontWeight: 700 }}
              >
                Slett valgte ({selectionModel.length})
              </MaterialButton>
            )}
            <MaterialButton
              variant="contained"
              onClick={handleClickOpen}
              startIcon={<PersonAddAlt1Icon sx={{ fontSize: 18 }} />}
              sx={{
                height: 40,
                borderRadius: '10px',
                textTransform: 'none',
                fontSize: 14,
                fontWeight: 700,
                bgcolor: '#BDECF3',
                color: '#087D9A',
                boxShadow: 'none',
                '&:hover': { bgcolor: '#A9E3EC', boxShadow: 'none' },
              }}
            >
              Opprett ny bruker
            </MaterialButton>
            <MaterialButton
              variant="contained"
              onClick={handleClickOpenGroup}
              startIcon={<GroupAddIcon sx={{ fontSize: 18 }} />}
              sx={{
                height: 40,
                borderRadius: '10px',
                textTransform: 'none',
                fontSize: 14,
                fontWeight: 700,
                bgcolor: '#BDECF3',
                color: '#087D9A',
                boxShadow: 'none',
                '&:hover': { bgcolor: '#A9E3EC', boxShadow: 'none' },
              }}
            >
              Opprett brukergruppe
            </MaterialButton>
          </Box>
        </Box>
        <Box sx={{ position: 'relative', flex: 1, minHeight: 0, width: '100%', padding: '0 24px 24px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
          {showLoadingState ? (
            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '16px' }}>
              <CircularProgress size={30} sx={{ color: '#23ABC7' }} />
            </Box>
          ) : searchableData.length === 0 ? (
            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, bgcolor: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '16px', color: '#64748B', fontSize: 14 }}>
              {searchValue.trim() ? (
                <>
                  <span>Fant ingen brukere for «{searchValue}»</span>
                  <MaterialButton onClick={() => setSearchValue('')} sx={{ textTransform: 'none' }}>
                    Tøm søket
                  </MaterialButton>
                </>
              ) : (
                'Ingen brukere tilgjengelig'
              )}
            </Box>
          ) : (
            <DataGrid
              getRowId={(row) => row.userId}
              onRowClick={handleRowClick}
              rows={searchableData}
              columns={columns}
              selectionModel={selectionModel}
              onSelectionModelChange={setSelectionModel}
              autoPageSize
              rowsPerPageOptions={[10, 25, 50]}
              checkboxSelection
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              rowHeight={52}
              headerHeight={42}
              getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              sx={{
                bgcolor: '#FFFFFF',
                border: '1px solid #E5E7EB',
                borderRadius: '16px',
                flex: 1,
                minHeight: 0,
                boxShadow: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  bgcolor: '#F8FAFC',
                  borderBottom: '1px solid #E5E7EB',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#334155',
                },
                '& .MuiDataGrid-columnSeparator': {
                  display: 'none',
                },
                '& .MuiDataGrid-cell': {
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #F1F5F9',
                  borderRight: 'none',
                },
                '& .even-row': {
                  bgcolor: '#FFFFFF',
                },
                '& .odd-row': {
                  bgcolor: '#F8FAFC',
                },
                '& .MuiDataGrid-row:hover': {
                  bgcolor: '#F1F5F9',
                },
                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                  outline: 'none',
                },
                '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                  outline: 'none',
                },
                '& .MuiDataGrid-footerContainer': {
                  bgcolor: '#F8FAFC',
                  borderTop: '1px solid #E5E7EB',
                },
              }}
            />
          )}
        </Box>
      </Flex>

    </View>
  );
}

export default withAuthenticator(Admin);


const formatSeason = (isWinter) => {
  return isWinter ? "Vinter" : "Sommer";
}
